import React, { useEffect, useState } from 'react';
import "../../assets/styles/Search.css";
import "../../assets/styles/Profile.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js"
import { config } from "../../config.js";
import { apiCheckDataAccount, apiFormUpdateAccount, apiGetRequestHistory, apiGetBanks } from "../../services/api.service.js";
import { maskRequestCode } from "../../utils/requestHistory.js";
// import iconArrow from "../../icons/";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import { AddPhotoAlternateOutlined, Close } from "@mui/icons-material";
import iconArrow from "../../icons/icon-arrow.png";
import iconSendMail from "../../icons/icon-send-mail.png";
import iconSendPhone from "../../icons/icon-send-phone.png";
import iconImage from "../../icons/icon-send-image.png";
import iconClose from "../../icons/icon-close.png";
import iconWarning from "../../icons/icon-warning.png";
import iconSuccess from "../../icons/icon-success.png";
import HomeIcon from '@mui/icons-material/Home';

/** Select ngân hàng có gõ để lọc danh sách */
function BankNameSelect({
  name = "bank_name",
  value = "",
  options = [],
  placeholder = "chọn ngân hàng",
  disabled = false,
  onChange,
}) {
  return (
    <Autocomplete
      className="bank-name-autocomplete"
      options={options}
      value={value || null}
      disabled={disabled}
      onChange={(_, newValue) => {
        onChange?.({ target: { name, value: newValue || "" } });
      }}
      filterOptions={(opts, state) => {
        const query = state.inputValue.trim().toLowerCase();
        if (!query) return opts;
        return opts.filter((opt) => String(opt).toLowerCase().includes(query));
      }}
      noOptionsText="Không tìm thấy ngân hàng"
      clearOnBlur={false}
      selectOnFocus
      handleHomeEndKeys
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
          }}
        />
      )}
    />
  );
}

function RequestProcessingStatus({
  submittedRequest,
  pollingChecks,
  isRefreshingRequest,
  requestRefreshMessage,
  refreshSubmittedRequest,
  copySubmittedRequestCode,
}) {
  if (!submittedRequest) return null;
  const needsVerification = ["email", "phone_number"].includes(submittedRequest.send_type);

  return (
    <div className={`request-processing-status status-${submittedRequest.status} verification-${needsVerification ? submittedRequest.verification_status || "not_received" : "success"}`}>
      {submittedRequest.status === "no_process" && (
        <div className={`request-live-update-notice ${pollingChecks >= 15 ? "request-live-update-stopped" : ""}`} role="status" aria-live="polite">
          {pollingChecks < 15 ? <span className="request-loading-icon" aria-hidden="true" /> : <span className="request-update-paused-icon" aria-hidden="true">✓</span>}
          <div>
            <strong>{pollingChecks < 15 ? "Hệ thống đang tự động cập nhật trạng thái" : ""}</strong>
            <small>{pollingChecks < 15 ? "Vui lòng giữ màn hình này mở và chờ kết quả xử lý." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
          </div>
        </div>
      )}
      <strong className="request-processing-title">
        {submittedRequest.status === "approved"
          ? "Yêu cầu đã được xử lý thành công"
          : submittedRequest.status === "removed"
            ? "Yêu cầu đã bị từ chối"
            : needsVerification && submittedRequest.verification_status === "invalid"
              ? "Đã nhận tin xác thực nhưng thông tin gửi không khớp"
            : needsVerification && submittedRequest.verification_status !== "success"
              ? "Yêu cầu đang chờ xác thực"
              : pollingChecks < 15 ? "Yêu cầu đang được xử lý" : "Yêu cầu đang được xử lý lâu hơn dự kiến"}
      </strong>
      <p className="submitted-request-code">Mã yêu cầu: <strong>{submittedRequest.request_code}</strong></p>
      {(submittedRequest.note || submittedRequest.result) && (
        <div className="request-result-note">
          <strong>Kết quả xử lý:</strong>
          <HtmlNote html={submittedRequest.note || submittedRequest.result} />
        </div>
      )}
      <div className="request-progress">
        <div className="request-progress-step step-complete"><span>1</span><small>Đã gửi yêu cầu</small></div>
        <div className={`request-progress-step ${!needsVerification || submittedRequest.verification_status === "success" ? "step-complete" : submittedRequest.verification_status === "invalid" ? "step-error" : "step-current"}`}>
          <span>2</span><small>{needsVerification ? "Xác thực" : "Đã tiếp nhận"}</small>
        </div>
        <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : needsVerification && submittedRequest.verification_status !== "success" ? "step-pending" : "step-current"}`}>
          <span>3</span><small>Đang xử lý</small>
        </div>
        <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : "step-pending"}`}>
          <span>4</span><small>Hoàn tất</small>
        </div>
      </div>
      {submittedRequest.status === "no_process" && (
        <div className="request-processing-message">
          {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "email" && <p>Chưa nhận xác thực. Vui lòng gửi từ email đã liên kết.</p>}
          {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "phone_number" && <p>Chưa nhận xác thực. Vui lòng gửi từ số điện thoại đã liên kết.</p>}
          {submittedRequest.verification_status === "invalid" && submittedRequest.send_type === "email" && <p>Đã nhận được email xác thực nhưng địa chỉ email gửi đến không khớp. Vui lòng gửi lại từ đúng email đã liên kết.</p>}
          {submittedRequest.verification_status === "invalid" && submittedRequest.send_type === "phone_number" && <p>Đã nhận được SMS xác thực nhưng số điện thoại gửi đến không khớp. Vui lòng gửi lại từ đúng SĐT đã liên kết.</p>}
          {submittedRequest.verification_status === "invalid" && !["email", "phone_number"].includes(submittedRequest.send_type) && <p>Xác thực không hợp lệ. Vui lòng kiểm tra thông tin và gửi lại.</p>}
          {pollingChecks >= 15 && (
            <>
              <p>Yêu cầu đang xử lý lâu hơn dự kiến.</p>
              <div className="request-processing-actions">
                <button type="button" onClick={refreshSubmittedRequest} disabled={isRefreshingRequest}>{isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}</button>
                <button type="button" onClick={copySubmittedRequestCode}>Sao chép mã</button>
              </div>
            </>
          )}
          {requestRefreshMessage && <p className="request-refresh-message" role="status">{requestRefreshMessage}</p>}
        </div>
      )}
    </div>
  );
}

function ChangeInfo() {
  const location = useLocation();
  const { userName, data, webSetting, typeModal } = location.state || {};
  const [openResult, setOpenResult] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [infoFileUpload, setInfoFileUpload] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_type_change: "",
    bank_edit_type: "",
    bank_name: "",
    bank_code: "",
    bank_number: "",
    email: "",
    phone_number: "",
  };
  const originalDesChangeBank = {
    title_change_bank: "THAY ĐỔI THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Mới",
  };
  const desBankNew = {
    title_change_bank: "THÊM THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Ngân Hàng Mới",
  };
  const desBankRemove = {
    title_change_bank: "XÓA SỐ TÀI KHOẢN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Cần Xóa",
    bank_number: "Số Tài Khoản Cần Xóa",
  };
  const desBankEdit = {
    title_change_bank: "SỬA THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Mới",
  };
  const desUSDTNew = {
    title_change_bank: "THÊM VÍ USDT",
    blockchain: "TRC20",
    bank_number: "Ví USDT Mới",
  };
  const [desChangeBank, setDesChangeBank] = useState(originalDesChangeBank);
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_name: "",
    bank_code: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });
  // danh sách ngân hàng setup ở admin: [{ code, name }], lỗi / rỗng thì dùng config.LIST_BANK_NAME
  const [banks, setBanks] = useState([]);
  const bankNameOptions = banks.length ? banks.map((bank) => bank.name) : config.LIST_BANK_NAME;
  const getBankCode = (bankName) => banks.find((bank) => bank.name === bankName)?.code || "";

  // "Sửa ngân hàng": ô bị khóa luôn lấy theo thông tin cũ, chưa chọn nội dung sửa thì khóa cả 2 ô
  const isEditBank = dataUpdate.bank_type_change === "Sửa ngân hàng";
  const lockBankName = isEditBank && !["Sửa tên ngân hàng", "Sửa stk và tên ngân hàng"].includes(dataUpdate.bank_edit_type);
  const lockBankNumber = isEditBank && !["Sửa stk ngân hàng", "Sửa stk và tên ngân hàng"].includes(dataUpdate.bank_edit_type);
  const newBankName = lockBankName ? dataCheck.bank_name : dataUpdate.bank_name;
  const newBankCode = lockBankName ? dataCheck.bank_code : dataUpdate.bank_code;
  const newBankNumber = lockBankNumber ? dataCheck.bank_number : dataUpdate.bank_number;
  
  
  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [pollingChecks, setPollingChecks] = useState(0);
  const [isRefreshingRequest, setIsRefreshingRequest] = useState(false);
  const [requestRefreshMessage, setRequestRefreshMessage] = useState("");

  const inputDataCheck = (event) => {
    let { name, value } = event.target;
    if (name === "email") {
      value = value.toLowerCase().replace(/\s+/g, "");
    }
    setDataCheck({
      ...dataCheck,
      [name]: value,
      // chọn ngân hàng: lưu kèm mã ngân hàng
      ...(name === "bank_name" && { bank_code: getBankCode(value) }),
    });
  };

  const inputDataUpdate = (event) => {
    const { name, value } = event.target;
    if (name == "bank_type_change") {
      // đổi yêu cầu thì xóa dữ liệu ngân hàng của lựa chọn trước
      const resetBank = { ...dataUpdate, bank_type_change: value, bank_edit_type: "", bank_name: "", bank_code: "", bank_number: "" };
      switch (value) {
        case "Thêm ngân hàng": setDesChangeBank(desBankNew)
        break;
        case "Xóa ngân hàng": setDesChangeBank(desBankRemove)
        break;
        case "Sửa ngân hàng": setDesChangeBank(desBankEdit)
        break;
        case "Thêm Ví USDT": setDesChangeBank(desUSDTNew)
          resetBank.bank_name = "TRC20";
        break;
        default: setDesChangeBank(originalDesChangeBank)
      }
      setDataUpdate(resetBank);
      return;
    }
    if (name === "bank_edit_type") {
      // chọn nội dung sửa: điền sẵn tên ngân hàng + số tài khoản theo thông tin cũ
      setDataUpdate({
        ...dataUpdate,
        bank_edit_type: value,
        bank_name: dataCheck.bank_name,
        bank_code: dataCheck.bank_code,
        bank_number: dataCheck.bank_number,
      });
      return;
    }
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
      ...(name === "bank_name" && { bank_code: getBankCode(value) }),
    });
  };
  let contentUpdate;

  useEffect(() => {
    updateUserField("update_type", typeModal)
  }, []);

  useEffect(() => {
    const fetchBanks = async () => {
      setBanks(await apiGetBanks());
    };
    fetchBanks();
  }, []);

  useEffect(() => {
    if (!openConfirm || !submittedRequest?.request_code || submittedRequest.status !== "no_process" || pollingChecks >= 15) {
      return undefined;
    }

    const intervalId = setInterval(async () => {
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      setPollingChecks((count) => count + 1);
      if (result?.code === 200 && result?.data?.request) {
        setSubmittedRequest(result.data.request);
      }
    }, 30 * 1000);

    return () => clearInterval(intervalId);
  }, [openConfirm, submittedRequest?.request_code, submittedRequest?.status, pollingChecks, userName]);

  useEffect(() => {
    const shouldLockScroll = openConfirm || openUploadFile || openResult;
    if (!shouldLockScroll) return undefined;

    // Khóa scroll nền khi popup modal mở để tránh lệch UI
    const previousOverflow = document.body.style.overflow;
    const previousTouchAction = document.body.style.touchAction;
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.touchAction = previousTouchAction;
    };
  }, [openConfirm, openUploadFile, openResult]);

  /**
   * @param {string} [verifyType] - mail|email|phone_number|files — email chỉ bắt buộc khi xác thực qua email
   */
  const validateForm = (verifyType) => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!dataCheck.name) {
      formIsValid = false;
      errors.name = 'Vui lòng nhập Họ và Tên';
    }

    // Kiểm tra trường phone_number
    if (data.phone_number) {
      if (!dataCheck.phone_number) {
        formIsValid = false;
        errors.phone_number = 'Vui lòng nhập Số Điện Thoại';
      } else if (!/^\d{10}$/.test(dataCheck.phone_number)) {
        formIsValid = false;
        errors.phone_number = 'Số Điện Thoại không hợp lệ';
      }
    }

    // Email: bắt buộc chỉ khi xác thực qua email; để trống thì không tính vào % thông tin cũ (BE)
    if (data.email) {
      const email = String(dataCheck.email || "").trim().toLowerCase();
      const requireEmail = verifyType === "mail" || verifyType === "email";
      if (requireEmail && !email) {
        formIsValid = false;
        errors.email = 'Vui lòng nhập Email để xác thực qua email';
      } else if (email && !/\S+@\S+\.\S+/.test(email)) {
        formIsValid = false;
        errors.email = 'Email không hợp lệ';
      }
    }

    // Kiểm tra trường bank_name
    if (!dataCheck.bank_name) {
      formIsValid = false;
      errors.bank_name = 'Vui lòng nhập Ngân Hàng';
    }

    // Kiểm tra trường bank_number
    if (!dataCheck.bank_number) {
      formIsValid = false;
      errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
    }
    switch (typeModal) {
      case "full_name": // Kiểm tra trường Name update
      if (!dataUpdate.name) {
        formIsValid = false;
        errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
      } else {
        contentUpdate = dataUpdate.name;
      }
      break;
      case "phone_number":// Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email":// Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = 'Vui lòng nhập Email mới';
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = 'Email mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank":// Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (isEditBank && !dataUpdate.bank_edit_type) {
          formIsValid = false;
          errors.bankEditType = 'Vui lòng chọn nội dung cần sửa';
        }
        if (!newBankName) {
          formIsValid = false;
          errors.bankNameUpdate = 'Vui lòng nhập Ngân Hàng mới';
        }
        if (!newBankNumber) {
          formIsValid = false;
          errors.bankNumberUpdate = 'Vui lòng nhập Số Tài Khoản mới';
        } else if (dataUpdate.bank_type_change !== "Thêm Ví USDT" && !/^\d{4,30}$/.test(newBankNumber)) {
          formIsValid = false;
          errors.bankNumberUpdate = 'Số Tài Khoản chỉ gồm chữ số';
        }
        if (isEditBank && dataUpdate.bank_edit_type && newBankName && newBankNumber) {
          const isSameName = newBankName === dataCheck.bank_name;
          const isSameNumber = newBankNumber === dataCheck.bank_number;
          if (dataUpdate.bank_edit_type === "Sửa tên ngân hàng" && isSameName) {
            formIsValid = false;
            errors.bankNameUpdate = 'Tên Ngân Hàng mới trùng với thông tin cũ';
          } else if (dataUpdate.bank_edit_type === "Sửa stk ngân hàng" && isSameNumber) {
            formIsValid = false;
            errors.bankNumberUpdate = 'Số Tài Khoản mới trùng với thông tin cũ';
          } else if (dataUpdate.bank_edit_type === "Sửa stk và tên ngân hàng" && isSameName && isSameNumber) {
            formIsValid = false;
            errors.bankNumberUpdate = 'Thông tin ngân hàng mới trùng với thông tin cũ';
          }
        }
        if (formIsValid) {
          // nội dung lấy theo ô tên ngân hàng + ô số tài khoản, giữ định dạng "<yêu cầu> - <stk> - <tên ngân hàng>"
          const bankRequestLabel = isEditBank
            ? `${dataUpdate.bank_type_change} (${dataUpdate.bank_edit_type})`
            : dataUpdate.bank_type_change;
          contentUpdate = ( bankRequestLabel + " - " + newBankNumber + " - " + newBankName )
        }
        break;
        case "birthday": // Kiểm tra trường birth day
          if (!dataUpdate.birth_day) {
            formIsValid = false;
            errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
          } else {
            contentUpdate = dataUpdate.birth_day;
          }
          break;
        case "forget_password":
          contentUpdate = "Lấy mật khẩu đăng nhập";
          break;
        case "forget_password_withdraw":
          contentUpdate = "Lấy mật khẩu rút tiền";
          break;
      default: break
    }
    console.log(errors)
    setErrors(errors);
    return formIsValid;
  };
  const modalConfirmUpdate = (type) => {
    if (validateForm(type)){
      if (type === 'files') {
          user.send_type = 'files';
          updateUserField('send_type', 'files')
          updateUser('files')
      } else {
        Swal.fire({
          icon: "warning",
          title: (type === "mail") ? `Bạn có thể sử dụng email ${data.email} để gửi mail xác thực thông tin?` : `Bạn có thể sử dụng số điện thoại ${data.phone_number} để gửi tin nhắn xác thực thông tin?`,
          text: (type === "mail") ? `Gửi SMS` : `Gửi email`,
          html: `
            <div className="confirm-update-wrapper">
            ${data.phone_number && type === "mail"
              ? '<button id="change_send_type" class="button-confirm-update">Xác nhận qua SMS</button>' 
              : data.email && type === "phone_number" ? '<button id="change_send_type" class="button-confirm-update">Xác nhận qua email</button>' : ''}
              <button id="confirm_send_type" class="button-confirm-update">Đúng, tiếp tục</button>
              </div>
              `,
          showCancelButton: false,
          showConfirmButton: false,
          didRender: () => {
            document.getElementById('change_send_type')?.addEventListener('click', () => {
              Swal.close();
              modalConfirmUpdate(type === "mail" ? "phone_number" : "mail");
            });
            document.getElementById('confirm_send_type').addEventListener('click', () => {
              Swal.close();
              updateUser(type)
            });
          }
        })
      }
    }
  }
  
  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };
  
  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };
  const refreshSubmittedRequest = async () => {
    if (isRefreshingRequest || !submittedRequest?.request_code) return;
    setIsRefreshingRequest(true);
    setRequestRefreshMessage("");
    const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
    if (result?.code === 200 && result?.data?.request) {
      setSubmittedRequest(result.data.request);
      setRequestRefreshMessage(`Đã cập nhật trạng thái mới nhất lúc ${new Date().toLocaleTimeString("vi-VN")}`);
    } else {
      setRequestRefreshMessage("Không thể cập nhật trạng thái. Vui lòng thử lại.");
    }
    setIsRefreshingRequest(false);
  };

  const copySubmittedRequestCode = async () => {
    try {
      await navigator.clipboard.writeText(submittedRequest?.request_code || "");
      setRequestRefreshMessage(`Đã sao chép: ${submittedRequest?.request_code}`);
    } catch (error) {
      setRequestRefreshMessage("Không thể sao chép mã yêu cầu.");
    }
  };

  const confirmUpdateUser = async (body, type) => {
    setLoading(true)
    let updateInfo = await apiFormUpdateAccount(body, selectedFiles);
    setLoading(false)
    const newRequestCode = updateInfo?.request_code;
    if (newRequestCode) {
      const newRequest = {
        ...body,
        request_code: newRequestCode,
        _request_code: newRequestCode,
        status: "no_process",
        verification_status: "not_received",
        createdAt: new Date().toISOString(),
      };
      user.request_code = newRequestCode;
      setUser((currentUser) => ({ ...currentUser, request_code: newRequestCode }));
      setSubmittedRequest(newRequest);
      setPollingChecks(0);
      setRequestRefreshMessage("");
      openModalConfirm(type);
    } else if (updateInfo) {
      openModalConfirm(type);
    }
  };
  const updateUser = async (type, submit) => {
    if (validateForm(type)) {
      if (type === "mail") {
        user.send_type = 'email';
        setIsSendMail(true);
      } else if (type === "phone_number") {
        user.send_type = 'phone_number';
        setIsSendMail(false);
      } else if (type === "files") {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...dataCheck,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
          // đổi ngân hàng: gửi thêm mã ngân hàng + số tài khoản (theo ô tên ngân hàng + ô số tài khoản)
          ...(user.update_type === "bank" && {
            bank_code: newBankCode || "",
            bank_number: newBankNumber || "",
          }),
        }
      };
      setLoading(true)
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false)
      if (checkDataOld) {
        if (type === "files" && !submit) {
          let descriptionFileUpload = "Bạn vui lòng tải lên ít nhất 3 trong " + webSetting?.des_up_files?.length+ " hình ảnh/video dưới để xác minh tài khoản<br/><br/>";
          if (webSetting?.des_up_files?.length > 0) {
            webSetting.des_up_files.forEach(element => {
              descriptionFileUpload +=  (element) ? "" + element + "</br>" : ""
            });
          }
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          setInfoFileUpload(descriptionFileUpload)
          setOpenUploadFile(true);
          return;
        }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        if (confirmUpdate || (timesCheckData >= 100 && checkDataOld.allowSubmit >0)) {
          confirmUpdateUser(body, type);
        } else {
          setLoading(false)
          Swal.fire({
            icon: (checkDataOld.countMatch/checkDataOld.count <0.5) ? "error" : "warning",
            title: "Chú ý",
            text: (checkDataOld.allowSubmit == 0 && type != 'files') ? "Sai số điện thoại và email liên kết" : "Thông tin cũ bạn nhập đúng " + Math.round(checkDataOld.countMatch/checkDataOld.count*100) + "%",
            showCancelButton: true,
            cancelButtonText: 'Quay về chỉnh sửa',
            confirmButtonText: 'Tiếp tục gửi',
            // chỉ khi có ít nhất 1 thông tin (số điện thoại hoặc email) đúng hoặc phương thức xác thực hình ảnh thì mới hiển thị nút confirm gửi yêu cầu
            showConfirmButton: (type === 'files' || checkDataOld.allowSubmit > 0),
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              confirmUpdateUser(body, type);
            } else if (result.isDismissed) {
              setTimesCheckData(timesCheckData + 1)
            }
          });
        }
      }
    }
  };
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    const nextRecentRequests = submittedRequest
      ? [
          { ...submittedRequest, request_code: maskRequestCode(submittedRequest.request_code) },
          ...(data?.recent_requests || []),
        ].slice(0, 2)
      : data?.recent_requests;
    navigate("/profile", { state: { userName, data: { ...data, recent_requests: nextRecentRequests }, webSetting } });
  };

  const handleMediaUpload = async (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter((file) => {
      if (file.size > 3 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `File ${file.name} vượt quá giới hạn 3MB.`,
        });
        return false;
      }
      return true;
    });
    
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    const newPreviews = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type.startsWith("image") ? "image" : "video"
    }));
    if (previews.length + newPreviews.length > 7) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 7 file",
      });
      return;
    }
    const base64Images = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Images]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <div className="container">
      <motion.div className="app">
        {/* <Header isPageSearch={false} pageToAcction={"/profile"} data={ {userName, data, webSetting} } currentPage={typeModal}/> */}
        <div className="content">
          {/* <HomeIcon 
            sx={{
              position: 'absolute',
              top: 20,
              right: 20,
              fontSize: 30,
              fill: '#FF9800',
              cursor: 'pointer'
            }}
            onClick={() => window.location.href = "https://new88bi.com/"}
          /> */}
          {(loading) && (
            <Loading loading={loading}/>
          )}
          <motion.div
            className="app"
            initial={{ x: "100vw", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "-100vw", opacity: 0 }}
            transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
          >
            <Header isPageSearch={false} pageToAcction={"/profile"} data={ {userName, data, webSetting} } currentPage={typeModal} webSetting={webSetting}/>

            <div className="content">
              {/* <Popup open={open} onClose={() => {setOpen(false); document.body.style.overflow = 'auto';}} position={"center"} closeOnDocumentClick={false} nested> */}
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} id="modal-info" className="modal-info">
                  {/* <div className="info-current">
                    <Collapsible open={false} trigger={["THÔNG TIN CÁ NHÂN", <img src={iconArrow} key="icon-arrow" alt="icon-arrow" />]}>
                      <InfoUser />
                    </Collapsible>
                  </div> */}
                  <div className="confirm-info-old">
                    <span className="modal-titlte">VUI LÒNG NHẬP LẠI THÔNG TIN ĐÃ LIÊN KẾT</span>
                    <div className="input-info">
                      <input type="text" name="name" value={dataCheck.name} onChange={inputDataCheck} placeholder="Họ Và Tên" />
                      {errors.name && <p className="error">{errors.name}</p>}
                      <input type="text" name="phone_number" value={dataCheck.phone_number} onChange={inputDataCheck} placeholder="Số Điện Thoại" />
                      {errors.phone_number && <p className="error">{errors.phone_number}</p>}
                      <input type="text" name="email" value={dataCheck.email} onChange={inputDataCheck} placeholder="Email" />
                      {errors.email && <p className="error">{errors.email}</p>}
                      <BankNameSelect
                        name="bank_name"
                        value={dataCheck.bank_name}
                        options={bankNameOptions}
                        onChange={inputDataCheck}
                        placeholder="chọn ngân hàng"
                      />
                      {errors.bank_name && <p className="error">{errors.bank_name}</p>}
                      <input type="text" name="bank_number" value={dataCheck.bank_number} onChange={inputDataCheck} placeholder="Số Tài Khoản" />
                      {errors.bank_number && <p className="error">{errors.bank_number}</p>}
                    </div>
                  </div>
                  <div className="confirm-info-new">
                    {
                      {
                        "full_name": 
                        <>
                          <span className="modal-titlte">THAY ĐỔI HỌ TÊN MỚI</span>
                          <div className="input-info">
                            <input type="text" name="name" onChange={inputDataUpdate} placeholder="Họ Tên Mới" />
                            {errors.nameUpdate && <p className="error">{errors.nameUpdate}</p>}
                          </div>
                        </>,
                        "phone_number": 
                        <>
                          <span className="modal-titlte">THAY ĐỔI SỐ ĐIỆN THOẠI MỚI</span>
                          <div className="input-info">
                            <input type="text" name="phone_number" onChange={inputDataUpdate}  placeholder="Số Điện Thoại Mới" />
                            {errors.phoneNumberUpdate && <p className="error">{errors.phoneNumberUpdate}</p>}
                          </div>
                        </>,
                        "email": 
                        <>
                          <span className="modal-titlte">THAY ĐỔI EMAIL MỚI</span>
                          <div class="input-info">
                            <input type="text" name="email" onChange={inputDataUpdate} placeholder="Email Mới" />
                            {errors.emailUpdate && <p className="error">{errors.emailUpdate}</p>}
                          </div>
                        </>,
                        "bank": 
                        <>
                          <span className="modal-titlte">{desChangeBank.title_change_bank}</span>
                          <div className="input-info">
                            <select type="input" name="bank_type_change" value={dataUpdate.bank_type_change} onChange={inputDataUpdate}>
                              <option value="">Chọn yêu cầu thay đổi</option>
                              {config.LIST_REQUEST_BANK.map((bank, index) => (
                                <option key={index} value={bank}>
                                  {bank}
                                </option>
                              ))}
                            </select>
                            {errors.bankTypeChange && <p className="error">{errors.bankTypeChange}</p>}
                            {/* sửa ngân hàng: chọn nội dung cần sửa */}
                            {isEditBank && <>
                              <select type="input" name="bank_edit_type" value={dataUpdate.bank_edit_type} onChange={inputDataUpdate}>
                                <option value="">Chọn nội dung cần sửa</option>
                                {config.LIST_EDIT_BANK.map((item, index) => (
                                  <option key={index} value={item}>
                                    {item}
                                  </option>
                                ))}
                              </select>
                              {errors.bankEditType && <p className="error">{errors.bankEditType}</p>}
                            </>}

                            <BankNameSelect
                              name="bank_name"
                              value={newBankName}
                              options={
                                desChangeBank.blockchain
                                  ? (dataUpdate.bank_name ? [dataUpdate.bank_name] : ["TRC20"])
                                  : bankNameOptions
                              }
                              disabled={Boolean(desChangeBank.blockchain) || lockBankName}
                              onChange={inputDataUpdate}
                              placeholder={desChangeBank.blockchain ?? "chọn ngân hàng"}
                            />
                            {errors.bankNameUpdate && <p className="error">{errors.bankNameUpdate}</p>}
                            <input type="text" name="bank_number" value={newBankNumber} disabled={lockBankNumber} onChange={inputDataUpdate} placeholder={desChangeBank.bank_number} />
                            {errors.bankNumberUpdate && <p className="error">{errors.bankNumberUpdate}</p>}
                          </div>
                        </>,
                        "birthday":
                        <div className="input-info">
                          <input type="date" name="birth_day" onChange={inputDataUpdate} placeholder="ngày tháng năm sinh" defaultValue="2000-12-01"/>
                          {errors.birthDayUpdate && <p className="error">{errors.birthDayUpdate}</p>}
                        </div>,
                        "forget_password":
                        <>
                          <span className="modal-titlte">LẤY MẬT KHẨU ĐĂNG NHẬP</span>
                          <p className="note-verify-image">Yêu cầu cấp lại mật khẩu đăng nhập. Vui lòng xác thực thông tin đã liên kết bên dưới.</p>
                        </>,
                        "forget_password_withdraw":
                        <>
                          <span className="modal-titlte">LẤY MẬT KHẨU RÚT TIỀN</span>
                          <p className="note-verify-image">Yêu cầu cấp lại mật khẩu rút tiền. Vui lòng xác thực thông tin đã liên kết bên dưới.</p>
                        </>,
                      }[typeModal]
                    }
                  </div>
                  <div className="mode-verify">
                    <span className="modal-titlte">VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC</span>
                    {(typeModal !== "birthday") &&
                    <>
                      <div className="action action-verify">
                        { data.email &&
                        <button onClick={() => updateUser("mail")} className="action-verify-btn">
                          <img src={iconSendMail} alt="icon-bank" />
                          &nbsp; XÁC THỰC EMAIL
                        </button>
                        }
                        { data.phone_number &&
                        <button onClick={() => updateUser("phone_number")} className="action-verify-btn">
                          <img src={iconSendPhone} alt="icon-bank" />
                          &nbsp; XÁC THỰC SĐT
                        </button>
                        }
                      </div>
                      <p className='note-verify-image'>
                        Nếu quý khách không có email hoặc SDT để gửi thông tin, vui lòng nhấn nút dưới đây để thực hiện thay thế
                      </p>
                    </>
                    }
                    <div className="action action-verify">
                      <button id="confirm_files_btn" onClick={() => updateUser("files")}>
                        <img src={iconImage} alt="icon-bank" />
                          &nbsp;&emsp; TẢI LÊN HÌNH ẢNH VIDEO THAY THẾ XÁC THỰC
                      </button>
                    </div>
                  </div>
                </motion.div>
              {/* </Popup> */}
              <Popup open={openConfirm} closeOnDocumentClick={false} onClose={closeModalConfirm} position={"center"} nested>
                <motion.div
                  initial={{ opacity: 0, y: 75 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  id="modal-confirm"
                  className="modal-confirm"
                >
                  <div className="modal-close">
                    <a className="icon-close" onClick={closeModalConfirm}>
                      <img src={iconClose} alt="icon-close" />
                    </a>
                  </div>
                    {user.send_type === 'files' ? (
                      <div className="modal-confirm-content">
                        <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                        <span>Yêu cầu của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt.</span>
                        <RequestProcessingStatus
                          submittedRequest={submittedRequest}
                          pollingChecks={pollingChecks}
                          isRefreshingRequest={isRefreshingRequest}
                          requestRefreshMessage={requestRefreshMessage}
                          refreshSubmittedRequest={refreshSubmittedRequest}
                          copySubmittedRequestCode={copySubmittedRequestCode}
                        />
                        <div className="btn-wrapper-home">
                          <div className="btn-send btn-home">
                              <a href={ webSetting.link_home }
                                  target="_blank"
                                  rel="noopener noreferrer">VỀ TRANG CHỦ
                              </a>
                          </div>
                        </div>
                        <div className="notification">
                          <p style={{ color: "#F7B922", padding: "3px 0px",margin: "0px"}}>Lưu ý:</p>
                          <p>- Quý khách vui lòng kiểm tra kết quả xử lý tại mục Lịch sử yêu cầu.</p>
                          <p>- Liên hệ <a href={ webSetting.link_cskh }
                            target="_blank"
                            rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                      </div>
                      </div>
                    ): (
                  <div className="modal-confirm-content">
                    <img className="icon-warning" src={iconWarning} />
                    {isSendMail ? (
                      <p>
                        Vui lòng sử dụng email đã liên kết <span style={{ color: "green" }}>{data.email}</span>, gửi tin nhắn tới email new88{" "}
                        <span style={{ color: "red" }}>{ webSetting.email }</span>, với nội dung:
                      </p>
                    ) : user.send_type === 'phone_number' ? (
                      <p>
                        Vui lòng sử dụng số điện thoại đã liên kết <span style={{ color: "green" }}>{data.phone_number}</span>, gửi tin nhắn tới số điện thoại new88{" "}
                        <span style={{ color: "red" }}>{ webSetting.phone_number }</span>, với nội dung:
                      </p>
                    ) : (
                      <p>
                        Yêu cầu của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt.
                      </p>
                    )}
                    <DataConfirm user={user}
                    dataCheck = {dataCheck}
                    dataUpdate = {dataUpdate}
                    webSetting = {webSetting}/>
                    <RequestProcessingStatus
                      submittedRequest={submittedRequest}
                      pollingChecks={pollingChecks}
                      isRefreshingRequest={isRefreshingRequest}
                      requestRefreshMessage={requestRefreshMessage}
                      refreshSubmittedRequest={refreshSubmittedRequest}
                      copySubmittedRequestCode={copySubmittedRequestCode}
                    />
                    <div className="notification">
                      <p style={{ color: "#F7B922", padding: "3px 0px",margin: "0px"}}>Lưu ý:</p>
                      <p>- Sau khi nhận được { (isSendMail) ? 'email' : 'tin nhắn' }, hệ thống xét duyệt từ 2-5 phút.</p>
                      <p>- Quý khách vui lòng kiểm tra kết quả xử lý tại mục Lịch sử yêu cầu.</p>
                      <p>- Liên hệ <a href={ webSetting.link_cskh }
                        target="_blank"
                        rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                  </div>
                  </div>
                  )}
                </motion.div>
              </Popup>
              <Popup open={openResult} onClose={() => setOpenResult(false)} position={"center"}>
                <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
                  <div className="modal-close">
                    <a className="icon-close" onClick={() => setOpenResult(false)}>
                      <img src={iconClose} alt="icon-close" />
                    </a>
                  </div>
                  {checkConfirm ? (
                    <div className="modal-result-content">
                      <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                      <span>Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ 2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ</span>
                    </div>
                    ) : (
                    <div className="modal-result-content">
                      <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success" />
                      <span>Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc liên hệ chăm sóc khách hàng</span>
                    </div>
                  )}
                </motion.div>
              </Popup>
              <Popup open={openUploadFile} onClose={() => setOpenUploadFile(false)} position={"center"}>
                <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
                  <div className="modal-close">
                    <a className="icon-close" onClick={() => setOpenUploadFile(false)}>
                      <img src={iconClose} alt="icon-close" />
                    </a>
                  </div>
                    <div className="modal-result-content">
                      <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success"/>
                      <span>Bạn cần cung cấp thêm hình ảnh/video để xác minh thông tin.</span>
                      
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{
                          color: "black",
                          marginBottom: "-10px",
                          marginTop: "-15px",
                          fontWeight: "bold",
                        }}
                      >
                        <div className='upload-file' dangerouslySetInnerHTML={{ __html: infoFileUpload }}/>
                      </Typography>
                      <Box
                        display="flex"
                        alignItems="center"
                        marginY={1}
                        flexWrap="wrap"
                        gap="8px 8px"
                      >
                        {previews.map((preview, index) => (
                          
                          <Box
                            onClick={() => handleRemoveImage(index)}
                            key={index}
                            sx={{
                              maxHeight: 80,
                              maxWidth: 90,
                              width: "auto",
                              height: "auto",
                              position: "relative",
                              overflow: "hidden",
                              cursor: "pointer",
                              "&:hover .delete-button": {
                                display: "block",
                              },
                            }}
                          >
                            {console.log("preview", preview)}
                          {preview.type === "image" ? (
                            <img
                              src={preview.url}
                              alt={`preview-${index}`}
                              style={{
                                width: "auto",
                                maxWidth: "100%",
                                height: "auto",
                                maxHeight: "100%",
                                borderRadius: 4,
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <video
                              src={preview.url}
                              controls
                              style={{
                                width: "auto",
                                maxWidth: "100%",
                                height: "auto",
                                maxHeight: "100%",
                                borderRadius: 4,
                                objectFit: "cover",
                              }}
                            />
                          )}
                            <IconButton
                              className="delete-button"
                              sx={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                color: "red",
                                p: 0,
                              }}
                            >
                              <Close fontSize="small" />
                            </IconButton>
                          </Box>
                        ))}
                        
                        <Box>
                          <input
                            accept="image/*, video/*"
                            style={{ display: "none" }}
                            id="upload-button"
                            type="file"
                            onChange={handleMediaUpload}
                            multiple
                          />
                          <label htmlFor="upload-button">
                            <Button
                              variant="outlined"
                              component="span"
                              startIcon={
                                <AddPhotoAlternateOutlined
                                  sx={{ fontSize: "large" }}
                                />
                              }
                              sx={{
                                width: "90px",
                                height: "80px",
                                color: "#6BB0C8",
                                borderColor: "#6BB0C8",
                                borderStyle: "solid",
                                "&:hover": {
                                  borderColor: "#6BB0C8",
                                  color: "#6BB0C8",
                                },
                              }}
                            >
                              Thêm
                            </Button>
                          </label>
                        </Box>
                      </Box>
                      <Typography variant="caption" sx={{ color: "#B0B3C1" }}>
                        Cung cấp hình ảnh/video đúng theo mô tả để được xét duyệt
                      </Typography>
                      {selectedImage.length >= 3 && (
                        <div>
                          <button id="complete_files_btn" onClick={() => {setOpenUploadFile(false); updateUser(user.send_type, true)}}>
                            Hoàn thành xác minh
                          </button>
                        </div>
                      )}
                    </div>
                </motion.div>
              </Popup>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}

export default ChangeInfo;
